var $db5c63cb8d95d7a4$exports = {};
$db5c63cb8d95d7a4$exports = {
    "pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`
};


export {$db5c63cb8d95d7a4$exports as default};
//# sourceMappingURL=el-GR.module.js.map
